import { FetchSegmentsPayload, Segment, SegmentsResponse } from './types';
import { LoadingStates } from '../../constants';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface SegmentManagerState {
  entities: {
    segments: Segment[];
    lastSyncAt?: string;
    totalRecords: number;
  };
  ui: {
    loading: {
      state: string;
    };
    filters: {
      sortBy?: string;
      sortOrder?: string;
      search?: string;
      platformType?: string;
      debouncedSearchText: string;
      page: number;
      recordPerPage: number;
    };
    notifications: Array<{
      state: string;
      message: string;
    }>;
  };
}

export const initialState: SegmentManagerState = {
  entities: {
    segments: [],
    lastSyncAt: undefined,
    totalRecords: 0,
  },
  ui: {
    loading: {
      state: LoadingStates.IDLE,
    },
    filters: {
      debouncedSearchText: '',
      platformType: 'OTS',
      page: 1,
      recordPerPage: 25,
    },
    notifications: [],
  },
};

const segmentManagerSlice = createSlice({
  name: 'segmentManager',
  initialState,
  reducers: {
    fetchSegments: (state, action: PayloadAction<FetchSegmentsPayload>) => {
      state.ui.loading.state = LoadingStates.LOADING;
    },
    setSegments: (state, action: PayloadAction<SegmentsResponse>) => {
      state.entities.segments = action.payload.segments || [];
      state.entities.lastSyncAt = action.payload.lastSyncAt;
      state.entities.totalRecords = action.payload.totalRecords || 0;
      state.ui.loading.state = LoadingStates.DONE;
    },
    setSegmentsLoading: (state, action: PayloadAction<{ state: string }>) => {
      state.ui.loading.state = action.payload.state;
    },
    updateFilters: (
      state,
      action: PayloadAction<Partial<FetchSegmentsPayload>>
    ) => {
      state.ui.filters = {
        ...state.ui.filters,
        ...action.payload,
      };
    },
    updateSearchAndResetPage: (state, action: PayloadAction<string>) => {
      state.ui.filters.debouncedSearchText = action.payload;
      state.ui.filters.page = 1;
    },
    addNotification: (
      state,
      action: PayloadAction<{ state: string; message: string }>
    ) => {
      state.ui.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.ui.notifications.splice(action.payload, 1);
    },
  },
});

export const {
  fetchSegments,
  setSegments,
  setSegmentsLoading,
  updateFilters,
  updateSearchAndResetPage,
  addNotification,
  removeNotification,
} = segmentManagerSlice.actions;

export default segmentManagerSlice.reducer;
